import { OrderData, EventInfo } from "../models"

export class DisplayOrder {
    orderData: OrderData
    eventInfos: EventInfo[]
}


// WEBPACK FOOTER //
// ./src/app/models/display-order.model.ts